<template>
  <article class="page-privacy-statement">
    <header v-if="showTitle">
      <p>
        为使用鲲鹏保险经纪服务平台（“鲲鹏保险经纪平台”）的服务，您应当阅读并遵守《鲲鹏保险经纪平台隐私声明》（以下简称“本隐私声明”）。&nbsp;<br />
      </p>
      <p>
        鲲鹏保险经纪平台，是指鲲鹏保险经纪（海南）有限公司（以下简称“鲲鹏保险经纪”）运营的包括但不限于“衡惠保”微信公众号等其他微信公众号、小程序、网页、网站、APP等线上平台。&nbsp;
      </p>
      <p>
        鲲鹏保险经纪非常重视您个人信息的保密和安全，并一直致力于依法保护您的个人信息。鉴此，鲲鹏保险经纪制定了本隐私声明，旨在向您说明：
      </p>
      <p>
        您在使用鲲鹏保险经纪提供的产品或服务时，鲲鹏保险经纪如何收集、使用、共享、转让、保护
        您的个人信息，以及为您提供管理您个人信息的途径和方法，因此建议您在使用鲲鹏保险经纪所提供的产品或服务前，务必仔细阅读本隐私声明，您需在充分理解并同意本隐私声明后，再使用相关产品或服务。一旦您点击同意本隐私声明，即表示您已充分理解并同意本隐私声明。&nbsp;
      </p>
      <p>
        为便于您了解本隐私声明内容，您可以根据以下提纲阅读相应章节:
      </p>
      <p>
        一、定义&nbsp;
      </p>
      <p>
        二、适用范围&nbsp;
      </p>
      <p>
        三、个人信息的收集、使用&nbsp;
      </p>
      <p>
        四、个人信息的共享、转让、公开披露&nbsp;
      </p>
      <p>
        五、个人信息的存储&nbsp;
      </p>
      <p>
        六、个人信息的保护&nbsp;
      </p>
      <p>
        七、使用 Cookies（网络跟踪器）和同类技术的政策&nbsp;
      </p>
      <p>
        八、未成年人隐私权保护&nbsp;
      </p>
      <p>
        九、查阅、更正个人信息的权利&nbsp;
      </p>
      <p>
        十、隐私声明的修订&nbsp;
      </p>
      <p>
        十一、如何联系鲲鹏保险经纪
      </p>
      <p>
        <br />
      </p>
      <p>
        一、定义&nbsp;
      </p>
      <p>
        1．个人信息：以电子或者其他方式记录的能够单独或者与其他信息结合识别特
        定自然人身份或者反映特定自然人活动情况的各种信息。&nbsp;
      </p>
      <p>
        2．匿名化：通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。&nbsp;
      </p>
      <p>
        <br />
      </p>
      <p>
        二、适用范围&nbsp;
      </p>
      <p>
        本隐私声明适用于通过鲲鹏保险经纪运营的包括但不限于“衡惠保”微信公众号等其他微信公众号、网页、网站、APP等线上平台向您提供的保险产品及相关增值服务。&nbsp;
      </p>
      <p>
        特别说明：除鲲鹏保险经纪通过上述平台向您提供的保险产品服务及相关增值服务外，本隐私声明不适用于其他任何第三方单独向您提供的服务。&nbsp;
      </p>
      <p>
        <br />
      </p>
      <p>
        三、个人信息的收集、使用鲲鹏保险经纪仅会出于本隐私声明所述的以下目的，收集和使用您的个人信息：&nbsp;
      </p>
      <p>
        （一）鲲鹏保险经纪如何收集您的个人信息
      </p>
      <p>
        1.帮助您成为鲲鹏保险经纪平台的注册用户&nbsp;
      </p>
      <p>
        成为鲲鹏保险经纪平台的注册用户，您需要提供手机号码进行账户注册并创建密码，或通过授权同意以您在第三方（包括微信、QQ、支付宝）注册的账户登录鲲鹏保险经纪平台。如果您不提供这类信息，鲲鹏保险经纪将无法为您创建账户。如果您仅需浏览部分页面，您不需要成为鲲鹏保险经纪平台的注册用户。
      </p>
      <p>
        如您主动注销账号时，鲲鹏保险经纪将及时停止继续收集您个人信息的行为。
      </p>
      <p>
        2.帮助您完成实名认证
      </p>
      <p>
        为完成实名认证，您需要提供您的姓名、身份证号、手机号码。如果您不提供这类信息，鲲鹏保险经纪将无法为您提供查询保单服务。如果您仅需浏览部分页面，您不需要进行实名认证。
      </p>
      <p>
        3.购买保险产品及保单管理
      </p>
      <p>
        为向您提供鲲鹏保险经纪的产品或服务，您需要提供您的个人信息或授权鲲鹏保险经纪向合法拥有您信息的第三方收集您的个人信息，实际需要提供或授权收集的个人信息，以您享受的产品或服务所必需的个人信息为准，包括：个人姓名、出生日期、身份证件号码、性别、住址、电话号码、电子邮箱、支付信息、设备信息、日志信息、征信信息、个人健康生理信息、基因检测疾病诊断证明。&nbsp;
      </p>
      <p>
        您提供或授权收集的上述信息可能会用于身份验证、资格审核、信用评估、客户服务、安全防范、诈骗监测、存档、备份，以确保鲲鹏保险经纪向您提供的产品和服务的适当性和安全性。对于您提供的个人信息，鲲鹏保险经纪会按照本声明承诺的标准进行保护。如您不提供前述信息，您将无法购买保险产品。
      </p>
      <p>
        为展示您投保的保单信息，鲲鹏保险经纪会收集您在使用鲲鹏保险经纪产品或服务过程中产生的保单信息用于向您展示及便于您对保单进行管理。&nbsp;
      </p>
      <p>
        4.帮助您完成支付
      </p>
      <p>
        为帮助您完成支付，您可以使用第三方所提供的支付服务。为实现支付服务的需要，鲲鹏保险经纪会收集并将您的保单号、交易金额、交易状态信息，以确认您已完成支付。如您不提供前述这些信息，可能将无法使用相关支付功能。
      </p>
      <p>
        5.向您展示或推送您可能感兴趣的产品或服务信息&nbsp;
      </p>
      <p>
        为改善鲲鹏保险经纪的保险产品或服务、向您提供个性化的信息搜索及交易服务，鲲鹏保险经纪可能会根据您的日志信息、设备信息、位置信息，提取您的浏览、搜索偏好、行为习惯，向您展示、推送信息。如果您不想接收鲲鹏保险经纪给您推送的信息，您可随时通过相应产品退订功能取消。&nbsp;
      </p>
      <p>
        6.供鲲鹏保险经纪统计或精算研究之用
      </p>
      <p>
        您使用鲲鹏保险经纪提供的产品或服务时，向鲲鹏保险经纪提供的或授权鲲鹏保险经纪收集的，会用于鲲鹏保险经纪出于自身管理或监管要求的保险统计，以及精算研究。&nbsp;
      </p>
      <p>
        7.提供安全保障&nbsp;
      </p>
      <p>
        为提高您使用本平台及鲲鹏保险经纪合作伙伴所提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、
        计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或监管
        规定的情况，鲲鹏保险经纪可能使用或整合您的注册账户信息、保单信息、理赔信息、设备信息、有关网络日志以及其他第三方取得您授权或依据法律共享的信息，来综合判断您注册账户及理赔风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。如您不提供上述信息，则鲲鹏保险经纪无法保证您在使用期间的鲲鹏保险经纪平台运行安全。
      </p>
      <p>
        8.联系鲲鹏保险经纪
      </p>
      <p>
        当您与鲲鹏保险经纪联系时，鲲鹏保险经纪可能会保存您的姓名、联系方式、留言信息、通信/通话记录，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。如您不提供上述信息，您的建议、反馈可能无法得到及时、有效处理，但不影响您正常使用鲲鹏保险经纪的其他服务。
      </p>
      <p>
        <br />
      </p>
      <p>
        （二）设备权限调用情况
      </p>
      <p>
        在您使用鲲鹏保险经纪平台过程中，鲲鹏保险经纪需要在必要范围内向您申请获取设备权限。请您知悉，鲲鹏保险经纪不会默认开启您设备的权限，仅在您主动确认开启的情况下，鲲鹏保险经纪平台才有可能通过设备权限收集您的信息。鲲鹏保险经纪平台调用的权限、调用权限的目的，以及调用权限前向您询问的情况请见下表：
      </p>
      <p>
        <br />
      </p>
      <p>
        设备权限<span style="white-space: pre;"></span>调用权限的目的<span
          style="white-space: pre;"
        ></span
        >是否询问<span style="white-space: pre;"></span>用户可否关闭权限
      </p>
      <p>
        网络<span style="white-space: pre;"></span>连接网络<span
          style="white-space: pre;"
        ></span
        >是<span style="white-space: pre;"></span>可
      </p>
      <p>
        位置信息<span style="white-space: pre;"></span>推送产品或服务<span
          style="white-space: pre;"
        ></span
        >是<span style="white-space: pre;"></span>可
      </p>
      <p>
        <br />
      </p>
      <p>
        （三）鲲鹏保险经纪如何使用您的个人信息
      </p>
      <p>
        1．鲲鹏保险经纪会根据本政策的约定并为实现鲲鹏保险经纪的服务的目的对所收集的个人信息进行使用。&nbsp;
      </p>
      <p>
        2．请您注意，您在使用鲲鹏保险经纪提供的服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝鲲鹏保险经纪收集，否则将在您使用鲲鹏保险经纪的服务期间持续授权鲲鹏保险经纪使用。在您注销账号时，鲲鹏保险经纪将停止使用并删除您的个人信息。
      </p>
      <p>
        3．鲲鹏保险经纪会对鲲鹏保险经纪提供的服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以用于产品开发、服务优化、安全保障的目的。但这些统计信息不包含您的任何身份识别信息。&nbsp;
      </p>
      <p>
        4．当鲲鹏保险经纪要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。&nbsp;
      </p>
      <p>
        <br />
      </p>
      <p>
        （四）其他规则
      </p>
      <p>
        若您提供的信息中含有他人的个人信息，在向鲲鹏保险经纪提供这些个人信息之前，您需要确保您已经取得合法的授权。
      </p>
      <p>
        当鲲鹏保险经纪要将您的个人信息用于本隐私声明未载明的其他用途，或将基于特定目的收集而来的个人信息用于其他目的时，会事先征求您的同意，但以下情况除外：
      </p>
      <p>
        1．与鲲鹏保险经纪履行法律法规规定的义务相关的；
      </p>
      <p>
        2．与国家安全、国防安全有关的；&nbsp;
      </p>
      <p>
        3．与公共安全、公共卫生、重大公共利益有关的；&nbsp;
      </p>
      <p>
        4．与刑事侦查、起诉、审判和判决执行等有关的；&nbsp;
      </p>
      <p>
        5．出于维护您或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
      </p>
      <p>
        6．所收集的个人信息是您自行向社会公众公开的；&nbsp;
      </p>
      <p>
        7．根据个人信息主体要求签订和履行合同所必需的；
      </p>
      <p>
        8．从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；&nbsp;
      </p>
      <p>
        9．用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障。
      </p>
      <p>
        <br />
      </p>
      <p>
        四、个人信息的共享、转让、公开披露&nbsp;
      </p>
      <p>
        （一）共享&nbsp;
      </p>
      <p>
        鲲鹏保险经纪不会与鲲鹏保险经纪以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：&nbsp;
      </p>
      <p>
        1．在获取明确同意的情况下共享：获得您的明确同意后，鲲鹏保险经纪会与其他方共享您的个人信息；&nbsp;
      </p>
      <p>
        2．在法定情形下的共享：鲲鹏保险经纪可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息；&nbsp;
      </p>
      <p>
        3．与授权合作伙伴共享：仅为实现本隐私声明中约定的目的，鲲鹏保险经纪在某些必要情形下可能与合作伙伴共享您的个人信息。
      </p>
      <p>
        鲲鹏保险经纪会将您的投保方案（被保险人与投保人关系、保障期间、生效日期、保额）、基本资料（个人姓名、出生日期、证件类型、证件号码、性别、电话号码、是否有社保）、缴费计划共享给保险公司，以确保您能购买该保险公司提供的保险产品。
      </p>
      <p>
        鲲鹏保险经纪仅会出于合法、正当、必要、特定的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。鲲鹏保险经纪的合作伙伴无权将共享的个人信息用于与产品或服务无关的其他用途。
      </p>
      <p>
        对鲲鹏保险经纪与之共享个人信息的公司、组织和个人，鲲鹏保险经纪会与其签署严格的数据保护协议，要求他们按照鲲鹏保险经纪的说明、本隐私声明以及其他任何相关的保密和安全措施来处理个人信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        （二）转让&nbsp;
      </p>
      <p>
        鲲鹏保险经纪不会将您的个人信息转让给任何公司、组织和个人，但以下情况
        除外:
      </p>
      <p>
        1．在获取明确同意的情况下转让：获得您的明确同意后，鲲鹏保险经纪方可向其他方转让您的个人信息；&nbsp;
      </p>
      <p>
        2．在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，鲲鹏保险经纪会要求新的持有您个人信息的公司、组织继续受本隐私声明的约束，否则，鲲鹏保险经纪将要求该公司、组织重新向您征求授权同意。
      </p>
      <p>
        <br />
      </p>
      <p>
        （三）公开披露&nbsp;
      </p>
      <p>
        除非本声明另有约定或法律明确规定，鲲鹏保险经纪不会公开披露您的个人信息。
      </p>
      <p>
        <br />
      </p>
      <p>
        （四）共享、转让、公开披露个人信息时事先征得授权同意的例外以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：&nbsp;
      </p>
      <p>
        1．与鲲鹏保险经纪履行法律法规规定的义务相关的；
      </p>
      <p>
        2．与国家安全、国防安全有关的；
      </p>
      <p>
        3．与公共安全、公共卫生、重大公共利益有关的；&nbsp;
      </p>
      <p>
        4．与刑事侦查、起诉、审判和判决执行等有关的；&nbsp;
      </p>
      <p>
        5．出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
      </p>
      <p>
        6．您自行向社会公众公开的个人信息；&nbsp;
      </p>
      <p>
        7．从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府
        信息公开等渠道。&nbsp;
      </p>
      <p>
        根据法律法规规定，共享、转让、公开披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
      </p>
      <p>
        <br />
      </p>
      <p>
        五、个人信息的存储&nbsp;
      </p>
      <p>
        在中华人民共和国境内收集和产生的个人信息，鲲鹏保险经纪将存储在中华人民共和国境内（不含港、澳、台地区）。
      </p>
      <p>
        如鲲鹏保险经纪需向境外传输您的个人信息的，则会先征得您的授权同意，并通过按照国家网信部门会同国务院有关部门制定的办法所要求的安全评估且要求接收方按照鲲鹏保险经纪的说明、本隐私声明以及其他任何相关的保密和安全措施来处理所接受的个人信息。
      </p>
      <p>
        鲲鹏保险经纪将在实现本隐私声明中所述目的所必需的期间保留您的个人信息，除非法律要求或允许在更长的期间内保留您的个人信息。
        前述期间届满之后，鲲鹏保险经纪会对您的个人信息删除或匿名化处理。
      </p>
      <p>
        <br />
      </p>
      <p>
        六、个人信息的保护
      </p>
      <p>
        鲲鹏保险经纪非常重视您的个人信息安全，会采取各种合理的物理、电子和管理方面的安全措施来保护您的个人信息，并尽最大合理努力使您的个人信息不会被泄露、毁损或者丢失，包括但不限于限制物理访问鲲鹏保险经纪系统内的数据及在转移敏感数据时进行加密处理等。鲲鹏保险经纪对可能接触到您个人信息的员工或外包人员也采取了严格管理，包括但不限于信息访问权限控制、与接触个人信息的人员签署保密协议、监控该等人员的操作情况等措施。&nbsp;
      </p>
      <p>
        鲲鹏保险经纪平台的注册账户信息（包括帐户名及密码信息）为非常重要的个人信息，请您妥善设置、保管您的注册账户信息。本平台将通过备份、对密码进行加密等安全措施以保护您的注册帐户信息等个人信息不丢失、不被滥用。
      </p>
      <p>
        尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。鲲鹏保险经纪亦不对由此产生或与之相关的任何风险、损失承担责任。
      </p>
      <p>
        在不幸发生个人信息安全事件后，鲲鹏保险经纪将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、鲲鹏保险经纪已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。鲲鹏保险经纪将及时将事件相关情况以应用程序推送、电子邮件、短信、电话等方式告知您，难以逐一告知个人信息主体时，鲲鹏保险经纪会采取合理、有效的方式发布公告。同时，鲲鹏保险经纪还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
      </p>
      <p>
        <br />
      </p>
      <p>
        七、使用 Cookies（网络跟踪器）和同类技术的政策&nbsp;
      </p>
      <p>
        为使您获得更为轻松的访问体验，您访问鲲鹏保险经纪平台或使用鲲鹏保险经纪提供的产品或服务，鲲鹏保险经纪可能会通过采用各种技术收集和存储相关信息，包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入注册信息的步骤，或者帮助判断您的帐户安全。这些数据可能是
        Cookies、Flash
        Cookies，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookies”）。&nbsp;
      </p>
      <p>
        第三方合作伙伴通过Cookies收集和使用您的信息不受本政策约束，而是受到其自身的信息保护声明约束，鲲鹏保险经纪不对第三方的Cookies或同类技术承担责任。
      </p>
      <p>
        请您理解，鲲鹏保险经纪的某些服务需要通过使用Cookies才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以修改对
        Cookies 的接受程度或者拒绝鲲鹏保险经纪平台的
        Cookies，但如拒绝，在某些情况下可能会影响您安全访问鲲鹏保险经纪平台。同时，您仍然将收到商品或服务信息，只是这些商品或服务信息与您的相关性会降低。
      </p>
      <p>
        <br />
      </p>
      <p>
        八、未成年人隐私权保护&nbsp;
      </p>
      <p>
        鲲鹏保险经纪重视未成年人的信息保护。如您为未成年人，您务必请您的父母或监护人仔细阅读本隐私声明，并在征得您父母或监护人同意的前提下才能向鲲鹏保险经纪提供信息、使用鲲鹏保险经纪的服务或购买本平台产品等。&nbsp;
      </p>
      <p>
        如您是未成年人的监护人，请您关注您所监护的未成年人是否是在您授权同意之后使用鲲鹏保险经纪的产品或服务。如果您对您所监护的未成年人的个人信息有疑问，请通过本隐私政策载明的方式与鲲鹏保险经纪联系。
      </p>
      <p>
        <br />
      </p>
      <p>
        九、您如何管理您的个人信息&nbsp;
      </p>
      <p>
        1．您可以通过本隐私政策载明的方式与鲲鹏保险经纪联系，核实鲲鹏保险经纪是否持有您的个人信息，并查阅您的个人信息；
      </p>
      <p>
        2．如鲲鹏保险经纪所持有的您的个人信息存在错误，您可以通过本隐私政策载明的方式鲲鹏保险经纪，要求更正您的个人信息。&nbsp;
      </p>
      <p>
        3．在以下情形中，您可以通过本隐私政策载明的方式向鲲鹏保险经纪提出删除个人信息的请求：
      </p>
      <p>
        （1）鲲鹏保险经纪违反法律、行政法规或与您的约定收集、使用个人信息；
      </p>
      <p>
        （2）鲲鹏保险经纪违反法律、行政法规或与您的约定与第三方共享或转让您的个人信息，鲲鹏保险经纪将立即停止共享、转让行为，并通知第三方及时删除；
      </p>
      <p>
        （3）鲲鹏保险经纪违反法律、行政法规规定或与您的约定，公开披露您的个人信息，鲲鹏保险经纪将立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息；
      </p>
      <p>
        （4）您不再使用鲲鹏保险经纪的服务，或您注销了账号，或鲲鹏保险经纪终止服务及运营。
      </p>
      <p>
        4．您可以通过设备权限设置或本隐私政策载明的方式与鲲鹏保险经纪联系，以改变同意范围或撤回您的授权。
      </p>
      <p>
        请您理解，鲲鹏保险经纪平台可能需要开启部分权限并收集必要的个人信息才能得以实现。当您撤回您的同意时，鲲鹏保险经纪将无法继续为您提供撤回同意所对应的服务，但不会影响此前基于您的授权而开展的个人信息处理服务。
      </p>
      <p>
        5．如果您希望注销您的账户，您可以根据本隐私政策载明的方式与鲲鹏保险经纪联系，鲲鹏保险经纪将及时响应您的请求。
      </p>
      <p>
        您注销上述账户的行为是不可逆的，鲲鹏保险经纪将停止为您提供产品或服务，不再收集您的个人信息，并依据您的要求删除与您账户相关的个人信息或做匿名化处理。
      </p>
      <p>
        6．响应您的上述请求
      </p>
      <p>
        如您无法按照上述方式行使权利的，您可以采取本隐私政策载明的联系方式与鲲鹏保险经纪联系。为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。鲲鹏保险经纪可能会先要求您验证自己的身份，然后再处理您的请求。&nbsp;
      </p>
      <p>
        对于您合理的请求，鲲鹏保险经纪原则上不收取费用，但对多次重复、超出合理限度的请求，鲲鹏保险经纪将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，鲲鹏保险经纪可能会予以拒绝。
      </p>
      <p>
        7．响应您的上述请求
      </p>
      <p>
        为保障安全，鲲鹏保险经纪可能会先要求您验证自己的身份，然后再处理您的请求。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，鲲鹏保险经纪可能会予以拒绝。&nbsp;
      </p>
      <p>
        在以下情形中，按照法律法规要求，鲲鹏保险经纪将无法响应您的请求：&nbsp;
      </p>
      <p>
        （1）与鲲鹏保险经纪履行法律法规规定的义务相关的；
      </p>
      <p>
        （2）与国家安全、国防安全有关的；&nbsp;
      </p>
      <p>
        （3）与公共安全、公共卫生、重大公共利益有关的；&nbsp;
      </p>
      <p>
        （4）与刑事侦查、起诉、审判和执行判决等有关的；&nbsp;
      </p>
      <p>
        （5）鲲鹏保险经纪有充分证据表明个人信息主体存在主观恶意或滥用权利的；&nbsp;
      </p>
      <p>
        （6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的;
      </p>
      <p>
        （7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；&nbsp;
      </p>
      <p>
        （8）涉及商业秘密的。&nbsp;
      </p>
      <p>
        <br />
      </p>
      <p>
        十、隐私声明的修订&nbsp;
      </p>
      <p>
        鲲鹏保险经纪可能适时修订本隐私声明，一旦本隐私声明内容发生变更，鲲鹏保险经纪会于鲲鹏保险经纪平台公布最新的隐私声明，并通过显著的方式通知您。未经您明确同意，鲲鹏保险经纪不会削减您按照本隐私政策所应享有的权利。
      </p>
      <p>
        若您在本隐私声明修订后继续使用鲲鹏保险经纪提供的产品或服务，这表示您已充分阅读、理解并愿意受修订后的隐私声明约束。
      </p>
      <p>
        <br />
      </p>
      <p>
        十一、如何联系鲲鹏保险经纪
      </p>
      <p>
        如果您对本政策或个人信息保护有任何问题，您可以将您的书面疑问、意见或建议通过以下地址寄至客服部门：
      </p>
      <p>
        名称：鲲鹏保险经纪（海南）有限公司
      </p>
      <p>
        地址：海南省海口市秀英区粤海大道155号海南未来产业园企业服务中心1-257-656&nbsp;
      </p>
      <p>
        或您也可以通过以下电话与客服部门进行联系：
      </p>
      <p>
        联系电话： 4000016600&nbsp;&nbsp;
      </p>
      <p>
        一般情况下，鲲鹏保险经纪将在十五个工作日内回复。如果您对鲲鹏保险经纪的回复不满意，特别是鲲鹏保险经纪的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。
      </p>
      <p>
        <br />
      </p>
    </header>
  </article>
</template>

<script>
  export default {
    name: 'PrivacyStatement',
    props: {
      showTitle: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      goPart(id) {
        document.getElementById(id).scrollIntoView()
      }
    }
  }
</script>

<style scoped lang="less">
  .page-privacy-statement {
    padding: 15px;
    color: #333;
    padding-top: 0;
    font-size: 15px;
    text-align: justify;
  }
</style>
